import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/aceites/revision_seguridad.svg")